// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import compareSegmentEndValues from './compareSegmentEndValues'
import preventCallsignCascadeCheck from './preventCallsignCascadeCheck'

// to determine if we need to trigger "callsign cascade 2" for the modified segment ends,
// look at initial values vs submit values for each segment end
// which has modified trigger values.

const getPathDetailsCallsignCascadeTriggerData = () => (dispatch, getState) => {
  const {
    form,
    pathDetails,
  } = getState()

  const sourceForm = pathDetails.get('sourceForm')

  // checks to see this submit should also trigger a Callsign Cascade
  // if not, then we just get outta here and return null for the caller to handle.
  if (dispatch(preventCallsignCascadeCheck())) {
    return null
  }

  const {
    initial,
    values,
  } = form[sourceForm]

  const callsignCascadeTriggerData = []

  // if the user flipped the path, we need to know that we're using different indexes
  // when comparing the difference between "site 1" and "site 2" data.
  const indexesMatch = (
    initial.sites[0].segmentEndId === values.sites[0].segmentEndId &&
    initial.sites[1].segmentEndId === values.sites[1].segmentEndId
  )

  // if the indexes don't match, then we will assume that the path was flipped.
  const site1SubmitIndex = indexesMatch ? 0 : 1
  const site2SubmitIndex = indexesMatch ? 1 : 0

  // so we'll compare the initial site 1 values to the submitted site 1 values
  const site1Initial = {
    ...initial.sites[0],
    ...initial.regulatory[0],
  }
  const site1Submit = {
    ...values.sites[site1SubmitIndex],
    ...values.regulatory[site1SubmitIndex],
  }

  // if there are any fields which were changed, store the old values of the trigger fields
  // so that we can pass this along to call the "callsign cascade 2 match end point."
  const site1TriggerInformation = compareSegmentEndValues(site1Initial, site1Submit)
  if (site1TriggerInformation !== null) {
    callsignCascadeTriggerData.push(site1TriggerInformation)
  }

  // do the same thing to site 2.
  const site2Initial = {
    ...initial.sites[1],
    ...initial.regulatory[1],
  }
  const site2Submit = {
    ...values.sites[site2SubmitIndex],
    ...values.regulatory[site2SubmitIndex],
  }

  const site2TriggerInformation = compareSegmentEndValues(site2Initial, site2Submit)
  if (site2TriggerInformation !== null) {
    callsignCascadeTriggerData.push(site2TriggerInformation)
  }

  // if there are no triggered fields, then return null, otherwise return callsignCascadeTriggerData
  return (
    callsignCascadeTriggerData.length > 0
      ? callsignCascadeTriggerData
      : null
  )
}

export default getPathDetailsCallsignCascadeTriggerData
